export const CMS_LANGS = [
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'ar', label: 'Arabic', short: 'AR' },
  { code: 'fr', label: 'French', short: 'FR' },
  { code: 'ru', label: 'Russian', short: 'RU' },
];

